import { render, staticRenderFns } from "./LocalOrderDetail.vue?vue&type=template&id=3d124d3c"
import script from "./LocalOrderDetail.vue?vue&type=script&lang=js"
export * from "./LocalOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports